export function handleUserStats(id, postType) {
    // get stats from sessionStorage
    const ctUserStats = JSON.parse(sessionStorage.getItem('ctUserStats')) ?? {};

    // add current data to the stats
    if (!ctUserStats[postType]) {
        ctUserStats[postType] = [id];
    } else {
        ctUserStats[postType].push(id);
    }

    const statsString = JSON.stringify(ctUserStats);
    // store updated data in sessionStorage
    sessionStorage.setItem('ctUserStats', statsString);

    return statsString;
}
